export const PROJECT_NODE_TYPE = {
  LOOKUP: 0,
  PROJECT: 1,
  JOB: 2,
} as const;
